import styled from 'styled-components';

import { basicTitleTextStyle, StrongText } from '@dreryk/react-components';

export const StyledStrongText = styled(StrongText)`
   ${basicTitleTextStyle}
`;
